export default __webpack_public_path__ + "static/media/approach3.ee0a07f6.png";